import { useColorModeValue } from '@/components/ui/color-mode'
import { Box, Flex } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'

/**
 * Auth Layout Component
 * Simple centered layout for login/register pages
 */
export function AuthLayout() {
  const bgColor = useColorModeValue('gray.50', 'gray.900')

  return (
    <Box minH="100vh" bg={ bgColor }>
      <Flex minH="100vh" align="center" justify="center" p={ 4 }>
        <Outlet />
      </Flex>
    </Box>
  )
}

export default AuthLayout
